import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import ProductsHeroSection from './ProductsHeroSection';
import ProductShowcaseSection from './ProductShowcaseSection';
import ProductEcosystemSection from './ProductEcosystemSection';
import FeaturesGridSection from '../features/FeatureGridSection';
import Features from '../features/Features';
import BetaWaitlistModal from './BetaWaitlistModal';
import FilmhookAIStudioModal from './FilmhookAIStudioModal';

export default function ProductsAllPages() {
  const [activeTab, setActiveTab] = useState(0);
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  const [waitlistProduct, setWaitlistProduct] = useState('Filmhook Editor');
  const [aiStudioOpen, setAiStudioOpen] = useState(false);
  const showcaseRef = useRef(null);
  const location = useLocation();

  const handleOpenWaitlist = (productName) => {
    if (productName === 'Filmhook AI' || productName?.toLowerCase().includes('ai')) {
      setAiStudioOpen(true);
      return;
    }
    setWaitlistProduct(productName || 'Filmhook Editor');
    setWaitlistOpen(true);
  };

  const handleScrollToProduct = (productKey) => {
    let tabIndex = 0;
    if (productKey === 'editor') {
      tabIndex = 1;
    } else if (productKey === 'ai') {
      tabIndex = 2;
    } else {
      tabIndex = 0;
    }
    setActiveTab(tabIndex);

    setTimeout(() => {
      if (showcaseRef.current) {
        const yOffset = -70;
        const y = showcaseRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }, 40);
  };

  useEffect(() => {
    const hash = location.hash?.toLowerCase() || '';
    const search = location.search?.toLowerCase() || '';
    if (hash.includes('editor') || search.includes('editor')) {
      handleScrollToProduct('editor');
    } else if (hash.includes('ai') || search.includes('ai')) {
      handleScrollToProduct('ai');
    } else if (hash.includes('apps') || search.includes('apps')) {
      handleScrollToProduct('apps');
    }
  }, [location.hash, location.search]);

  return (
    <Box sx={{ width: '100%', overflowX: 'hidden' }}>
      {/* 1. Hero Section showcasing the 3 Products */}
      <ProductsHeroSection onScrollToProduct={handleScrollToProduct} />

      {/* 2. Flagship 3 Products Deep-Dive Showcase */}
      <ProductShowcaseSection
        activeSectionRef={showcaseRef}
        selectedTab={activeTab}
        onTabChange={setActiveTab}
        onOpenWaitlist={handleOpenWaitlist}
      />

      {/* 3. Product Synergy & Workflow Ecosystem */}
      <ProductEcosystemSection />

      {/* 4. Detailed Features Grid (Filmhook Apps In-Depth) */}
      <FeaturesGridSection />

      {/* 5. Rich Category Showcase & Detailed Modals */}
      <Features />

      {/* 6. Interactive Waitlist / Early Access Modal */}
      <BetaWaitlistModal
        open={waitlistOpen}
        onClose={() => setWaitlistOpen(false)}
        defaultProduct={waitlistProduct}
        onOpenAiStudio={() => setAiStudioOpen(true)}
      />

      {/* 7. Filmhook AI Interactive Studio Modal */}
      <FilmhookAIStudioModal
        open={aiStudioOpen}
        onClose={() => setAiStudioOpen(false)}
      />
    </Box>
  );
}
